import React, { useState, useRef, useEffect } from 'react'

type SubmitButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>
  loadingContent?: React.ReactNode
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ onClick, disabled, children, loadingContent, type, ...props }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isMounted = useRef(true)

  useEffect(() => () => { isMounted.current = false }, [])

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isSubmitting || disabled || !onClick) return

    setIsSubmitting(true)
    try {
      await onClick(event)
    } finally {
      if (isMounted.current) setIsSubmitting(false)
    }
  }

  return (
    <button {...props} type={type || 'button'} disabled={isSubmitting || disabled} onClick={handleClick}>
      {isSubmitting && loadingContent !== undefined ? loadingContent : children}
    </button>
  )
}

export default SubmitButton
